import { motion } from "motion/react";
import { Search, Briefcase, ArrowRight, Mail } from "lucide-react";
import { Link } from "react-router";

export function CareersPage() {
  return (
    <div className="pt-20">
      {/* Hero Header */}
      <section className="bg-slate-900 text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img 
            src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxlbXB0eSUyMG9mZmljZSUyMGNoYWlyJTIwc3BvdGxpZ2h0JTIwY2FyZWVycyUyMGhpcmluZ3xlbnwxfHx8fDE3NzE1MjQ1MzR8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral" 
            alt="Careers at Intelisine" 
            className="w-full h-full object-cover blur-sm"
          />
          <div className="absolute inset-0 bg-slate-900/80"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-[#FD5750] font-bold tracking-widest uppercase mb-4 block">Join Our Team</span>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Build the <span className="text-[#FD5750]">Future</span> With Us
            </h1>
            <p className="text-slate-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
              We are always looking for passionate individuals who want to redefine the IT services landscape.
            </p>
          </motion.div>
        </div>
      </section>

      {/* No Openings Section */}
      <section className="py-24 bg-white min-h-[50vh] flex flex-col items-center justify-center">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <motion.div
             initial={{ opacity: 0, scale: 0.9 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5 }}
             className="bg-slate-50 border border-slate-200 rounded-3xl p-12 shadow-sm"
          >
             <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6 text-slate-400">
                <Briefcase size={40} />
             </div>
             
             <h2 className="text-3xl font-bold text-slate-900 mb-4">No Current Openings</h2>
             <p className="text-slate-600 text-lg mb-8 leading-relaxed">
               Thank you for your interest in joining Intelisine. While we don't have any open positions at the moment, we are growing fast and opportunities arise frequently.
             </p>
             
             <div className="bg-white border border-slate-200 rounded-xl p-6 text-left">
                <h3 className="text-lg font-bold text-slate-900 mb-2 flex items-center gap-2">
                   <Mail size={18} className="text-[#FD5750]" />
                   Don't miss out!
                </h3>
                <p className="text-slate-600 mb-4 text-sm">
                   Send your resume to our talent pool. We'll contact you as soon as a role matching your skills opens up.
                </p>
                <a 
                   href="mailto:careers@intelisine.com"
                   className="inline-flex items-center gap-2 text-[#FD5750] font-bold hover:underline"
                >
                   Email us your resume <ArrowRight size={16} />
                </a>
             </div>
          </motion.div>
          
          <div className="mt-12 text-slate-500 text-sm">
             <p>Follow us on <a href="#" className="text-[#FD5750] hover:underline">LinkedIn</a> for the latest updates on new roles.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
